/**
 * Definitions for non-session related auth types
 */
export var AuthMode = /*#__PURE__*/function (AuthMode) {
  AuthMode["signup"] = "signup";
  /**
   * Used for flows that include the quiz, as they'll sign in in a
   * modal on a quiz page instead of on the credentials page
   */
  AuthMode["quizSignup"] = "quizSignup";
  /**
   * Used for prepaid code activation
   */
  AuthMode["activateSignup"] = "activateSignup";
  AuthMode["login"] = "login";
  return AuthMode;
}(AuthMode || {});